// extracted by mini-css-extract-plugin
module.exports = {"root":"_0e0168","list":"_738ffd","item":"_6d9921","ratingText":"_d5f82d"};